import { render, staticRenderFns } from "./SignUpOtp.vue?vue&type=template&id=495ac0d6&scoped=true"
import script from "./SignUpOtp.vue?vue&type=script&lang=js"
export * from "./SignUpOtp.vue?vue&type=script&lang=js"
import style0 from "./SignUpOtp.vue?vue&type=style&index=0&id=495ac0d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495ac0d6",
  null
  
)

export default component.exports